<template>
    <div class="navbar">
        <nav class="deep-purple darken-1">
            <div class="container">
                <a href="" class="brand-logo left">
                    <router-link :to="{ name: 'GMap' }">
                        GeoMeow
                    </router-link>
                </a>
                <ul class="right">
                    <li v-if="!user"><router-link :to="{ name: 'SignUp' }">SignUp</router-link></li>
                    <li v-if="!user"><router-link :to="{ name: 'Login' }">Login</router-link></li>
                    <li class="logout" v-if="user"><a @click="logout" href=""><i class="material-icons">face</i>Logout</a></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import firebase from 'firebase'
export default {
    name: 'Navbar',
    data() {
        return {
           user: null
        }
    },
    methods: {
        logout() {
            firebase.auth().signOut()
            .then(() => {
                this.$router.push({ name: 'Login' })
            })
        }
    },
    created() {
        let user = firebase.auth().currentUser
        firebase.auth().onAuthStateChanged(user => {
            if(user) {
                this.user = user
            } else {
                this.user = null
            }
        })
    }
}
</script>

<style>
  .logout a {
     display: flex;
  }
  
  @media screen and (min-width: 768px ) {
      .logout i {
      position: relative;
      top: 3px;
      right: 2px;
  }
  }
  
</style>





// WEBPACK FOOTER //
// src/components/layout/Navbar.vue